import React from 'react'
import { cn } from './cn'

// Tailwind replacement for CoreUI's <CContainer>. Not used by the first
// migrated page yet, but included now since CContainer is CoreUI's most
// widely used component in this codebase (~60 call sites) — the next page
// migrated off CoreUI will very likely need it.
export const Container = React.forwardRef(
  ({ fluid = false, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'tw-w-full tw-mx-auto tw-px-4',
        !fluid && 'tw-max-w-screen-xl',
        className
      )}
      {...props}
    />
  )
)
Container.displayName = 'Container'
